import React from "react";
import Navbar from "./Navbar/Navbar";
import Footer from "./Footer/Footer";
import styled from "styled-components";
import 'bootstrap/dist/css/bootstrap.min.css';

// Inner Components
const Container = styled.div`
  background-color: #FAFAFA;
`;

const Layout = ({ children, cartKey = ''  }) => {

  return (
    <Container id="scroll-container">
      <div style={{ backgroundColor: 'white' }}>
        <Navbar key={cartKey} />
      </div>
      {children}
      <Footer />
    </Container>
  );
}

export default Layout;
